import { PlayerContextState } from "./PlayerContext";

let cache: Record<string, [number, number]> = {};

export function cacheByTickCount(
  state: PlayerContextState,
  keyFn: (state: PlayerContextState) => string,
  valueFn: (state: PlayerContextState) => any,
  readCacheOnly?: boolean,
) {
  if (state.isFake) {
    return valueFn(state);
  }
  const tickCount = state.global.tickCount;
  const key = keyFn(state);
  if (!cache?.[key] || (!readCacheOnly && cache[key][0] != tickCount)) {
    cache[key] = [tickCount, valueFn(state)];
  }
  return cache[key][1];
}

export function cacheBySecondsPlayed(
  state: PlayerContextState,
  keyFn: (state: PlayerContextState) => string,
  valueFn: (state: PlayerContextState) => any,
  readCacheOnly?: boolean,
) {
  if (state.isFake) {
    return valueFn(state);
  }
  const tickCount = state.thisRun.secondsPlayed;
  const key = keyFn(state);
  if (!cache?.[key] || (!readCacheOnly && cache[key][0] != tickCount)) {
    cache[key] = [tickCount, valueFn(state)];
  }
  return cache[key][1];
}

const clearCacheListeners: Record<string, () => void> = {};

export function clearAllCaches() {
  cache = {};
  for (let listener of Object.values(clearCacheListeners)) {
    listener();
  }
}

export function registerClearCacheListener(id: string, fn: () => void) {
  clearCacheListeners[id] = fn;
}
